<manage-wrapper
  *ngIf="!!task"
  [canEditMain]="!readOnly"
  [entityTitle]="task.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="readOnly"
  [labels]="task.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [deleteTitle]="'Delete this task'"
  [canDuplicate]="false"
  [labelUpdateFunction]="readOnly || limited ? null : labelUpdateFunction.bind(this)"
  [type]="'task'"
  [whiteTitle]="true"
  [titlePlaceholder]="'Task'"
  [showCheck]="false"
  [fullHeight]="selectedTab?.id === taskTabs.messages"
  [midRightLabel]="data.fromHome ? 'VIEW EVENT' : null"
  [checked]="task.completed"
  backgroundColor="#41474F"
  dialogTitle="Task details"
  (onDone)="exit()"
  (onCheck)="readOnly ? null : toggleComplete()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTaskName($event)"
  (onMidRight)="viewEvent()"
  (onDelete)="delete()"
>

  <task-status-dropdown *ngIf="!!task" class="in-toggles" [task]="task"></task-status-dropdown>
  <div class="beforeTitle">
    <div class="title"><icon class="event_18" icon="event_18"></icon>{{ event?.title || "" }}</div>
    <div class="dates" *ngIf="eventDateString">&nbsp;({{eventDateString}})</div>
    <div class="account" *ngIf="account">
      &nbsp;|&nbsp;
      <photo [size]="18" [data]="account"></photo>
      <div class="account-name" [title]="account.title">{{account.title}}</div>
    </div>
  </div>
  <div class="afterTitle">

    <menu-hover-button [readOnly]="readOnly" class="flag smooth" iconSelector="flagoff" hoverText="Flag" [tooltipLeft]="true"
      [warn]="task.flag" (click)="readOnly ? null : toggleFlagged()">
    </menu-hover-button>
    
    <menu-hover-button [readOnly]="readOnly" class="calendar smooth" iconSelector="calendar" hoverText="Manage due date"
      [text]="!task?.dueDate ? 'Due date' : task.dueDate | date:'EEE d MMM'" [lightText]="!task?.dueDate" (click)="limited || readOnly ? null : picker.open()">
      <mat-form-field class="date_field">
        <input hidden matInput id="date" name="date" #pickerInput [matDatepicker]="picker" [ngModel]="task.dueDate" (ngModelChange)="setDueDate($event)">
        <mat-datepicker class="picker" #picker [startAt]="task?.date || today"></mat-datepicker>
      </mat-form-field>
    </menu-hover-button>
    
    <menu-hover-button [readOnly]="readOnly" *ngIf="!!task.dueDate && !limited && !readOnly" class="delete-date" iconSelector="delete18"
      [noBackground]="true" hoverText="Remove due date" (click)="removeDueDate($event)"></menu-hover-button>

    <menu-hover-button [readOnly]="readOnly" id="responsibilityButton" *ngIf="{w: workersByEmail[task?.responsibility]} as w" [iconSelector]="!w.w ? 'ADD_TO_WORKFORCE' : null"
      hoverText="Manage responsibility" [text]="!w.w ? 'Responsibility' : w.w.firstName + ' ' + w.w.lastName" 
      [lightText]="!w.w" [worker]="w.w" (click)="limited || readOnly ? null : setResponsibleWorker()"></menu-hover-button>
    
    <menu-hover-button [readOnly]="readOnly" class="programButton" *ngIf="{p: programEntities[task.program]} as p" 
      iconSelector="column_multi" [text]="p.p ? p.p.title : uiService.programTerm.btn"
      [hoverText]="'Select ' + uiService.programTerm.btn_lower" [lightText]="!p.p">
      <mat-select [disabled]="readOnly || limited" tabindex="-1" (selectionChange)="updateProgram()" [(ngModel)]="task.program" [placeholder]="uiService.programTerm.btn" [panelClass]="task.program ?  'programPanel selected' : 'programPanel'">
        <mat-option [value]="null">None</mat-option>
        <mat-option *ngFor="let prog of programs" [value]="prog.id">{{prog.title}}</mat-option>
      </mat-select>
    </menu-hover-button>

    <menu-hover-button [readOnly]="readOnly" *ngIf="{all: task.groupVisibility?.includes('--all--'), another: task.groupVisibility?.length > 1 || task.visibility?.length > 1 } as v" id="visibilityButton"
      class="visiblity-button" hoverText="Manage visibility" [iconSelector]="v.all ? v.another ? 'UNLOCKED_EYE' : 'VISIBILITY24' : 'READ_ONLY24'"
      [lightText]="v.all" [text]="v.all ? v.another ? 'Extended' : 'Program & Logistics Teams' : 'Limited'" (click)="limited || readOnly ? null : manageVisibility()"></menu-hover-button>

    <div class="estimated-time-holder">
      <menu-hover-button [readOnly]="readOnly" class="estimated-time smooth" iconSelector="time24" hoverText="Estimated time"
        [text]="!timeLogSummary?.estimatedTime ? 'Est. time' : timeLogSummary.estimatedTime | justTimeToHHMM" 
        [lightText]="!timeLogSummary?.hasEstimatedTime"
        [progress]="timeLogSummary?.percentDone" [warn]="timeLogSummary?.percentDone > 100"
        (click)="readOnly ? null : toggleEstimatedTime($event, !showEstimatedTime)">
      </menu-hover-button>
      <div class="estimated-input" (clickOutside)="toggleEstimatedTime($event, false, true)" (mouseenter)="$event.stopPropagation()" (click)="$event.stopPropagation()" *ngIf="showEstimatedTime">
        <div class="text">Estimated time:</div>
        <joi-hm-input [allowNoValue]="true" (timeChange)="changeEstimatedTime($event)" [startingJustTime]="task.estimatedTime" [minMinutes]="0"></joi-hm-input>
        <button class="tiny-button" mat-button color="primary" (click)="toggleEstimatedTime($event, false)" >DONE</button>
      </div>
    </div>

    <menu-hover-button [readOnly]="readOnly" id="entityButton" class="entity-button" [hoverText]="'Associate task with...'"
      [iconSelector]="'associate'" [lightText]="!entities[task.entityId]" (click)="limited || readOnly ? null : associateTask()"
      [text]="entities[task.entityId]?.name || 'Associated with'"></menu-hover-button>

    <menu-hover-button [readOnly]="readOnly" *ngIf="workersByUId[task?.createdBy] as creator" class="creator" [noBackground]="true" 
      [hoverText]="'Created by ' + creator.firstName + ' ' + creator.lastName" [worker]="creator"></menu-hover-button>

  </div>

  <ng-container *ngIf="!selectedTab || selectedTab?.id === taskTabs.info">
    
    <title-icon [title]="'Additional information'" titleIcon="description18"></title-icon>
    <joi-input [disabled]="readOnly" [italicPlaceholder]="true" [(model)]="task.content" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add additional information...'" (joiChange)="saveTask()"></joi-input>
    
    <add-manage-wrapper class="subtask-list" 
      cdkDropList  
      (cdkDropListDropped)="dropSubtaskIds($event)"
      [titleIcon]="'tick18'" 
      [wrapperTitle]="'Subtasks'" 
      [wrapperSubtitle]="task?.subtasks?.length ? '(' +  (task.subtasksCompleted || 0) + '/' + task.subtasks.length + ')' : null" [openLabel]="readOnly ? null : '+ ADD A SUBTASK'"
      [hideHRule]="true" 
      (open)="addSubtask()"
    >
      <ng-container *ngIf="task.subtasks?.length">
        <div class="subtasks-holder" *ngFor="let subtaskId of task.subtasks">
          <div class="subtask drag-wrapper" cdkDrag *ngIf="task.subtasks_obj[subtaskId] as sub">
              <icon class="handle sub-handle" matIcon="drag_indicator" cdkDragHandle></icon>
              <div class="check-name-holder">
                <icon class="check" (click)="readOnly ? null : toggleSubtask(sub)" [ngClass]="{checked: !!sub.completed, canCheck: !readOnly}" [icon]="!!sub.completed ?  'task_complete_24px' : 'task_incomplete_24px'"></icon>
                <joi-input [disabled]="readOnly" [italicPlaceholder]="true" [type]="'textarea'" [returnable]="true" [id]="subtaskId"  [ngClass]="{completed: !!sub.completed}" [(model)]="sub.name" [placeholder]="'Subtask...'" (joiChange)="saveSubtaskName(sub)"></joi-input>
              </div>
              <icon class="delete smooth" (click)="readOnly ? null : deleteSubtask(sub, $event)" [ngClass]="{canDelete: !readOnly}" icon="delete18"></icon>
          </div>
        </div>
      </ng-container>
      
    </add-manage-wrapper>
    
    <title-icon class="margin-top" [title]="'Files'" [titleIcon]="'attachment'"></title-icon>
    <file-handler 
      [data]="task"
      [readfilesonly]="readOnly"
      (dataChange)="saveFiles($event)"
    ><div class="empty" *ngIf="!task.files?.length">No files.</div></file-handler>
  </ng-container>


  <ng-container *ngIf="selectedTab?.id === taskTabs.messages">
    <chat-box [readOnly]="readOnly" [comments]="task.comments || []" (addComment)="addComment($event)"></chat-box>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === taskTabs.logs">
    <time-log 
      [taskTitle]="task.name"
      [timeLogSummary]="timeLogSummary"
      [timeLogData]="timeLogData"
      [readOnly]="readOnly"
      (newLog)="addLog($event)"
      (editedLog)="editLog($event)"
      (deleteLog)="deleteLog($event)"
    ></time-log>
  </ng-container>
</manage-wrapper>